// extracted by mini-css-extract-plugin
module.exports = {"rightIcon":"index-module_rightIcon_3jJ9u"};